(function (root, factory) {
  'use strict';
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root) root.ZUGAirFreshenerProductContract = api;
})(typeof window !== 'undefined' ? window : this, function () {
  'use strict';

  var EXPECTED_PRODUCTS = {
    7274906189887: 'bulk-custom-air-fresheners',
    7275628625983: 'air-fresheners-w-header-card',
    7276009848895: 'air-fresheners-w-backer-card',
    7565869219903: 'custom-air-fresheners-bogo',
    7192097849407: 'custom-air-fresheners'
  };
  var PACKAGING = ['none', 'header_card', 'backer_card'];

  function positiveInteger(value) {
    var number = Number(value);
    return Number.isInteger(number) && number > 0 ? number : 0;
  }

  function normalizeHandle(value) {
    return String(value || '').trim().toLowerCase();
  }

  function prepare(raw) {
    if (!raw || raw.schemaVersion !== 1 || raw.status !== 'production_air_freshener_products' ||
        raw.family !== 'air_freshener' || raw.contractVersion !== 'air_freshener_products_v1' ||
        !raw.surcharges || positiveInteger(raw.surcharges.extraFragranceCents) !== 300 ||
        positiveInteger(raw.surcharges.doubleImageCents) !== 500 || !Array.isArray(raw.products) ||
        raw.products.length !== Object.keys(EXPECTED_PRODUCTS).length) {
      throw new Error('Air Freshener product contract is invalid.');
    }

    var seen = {};
    var products = raw.products.map(function (input) {
      var productId = positiveInteger(input.productId);
      var handle = normalizeHandle(input.handle);
      var expectedHandle = EXPECTED_PRODUCTS[productId];
      if (!expectedHandle || expectedHandle !== handle || seen[productId] ||
          ['exact', 'interpolated', 'bounded_interpolated_flat'].indexOf(input.pricingMode) === -1 ||
          PACKAGING.indexOf(input.packaging) === -1 ||
          !Array.isArray(input.quantities) || !Array.isArray(input.unitCents) ||
          input.quantities.length < 2 || input.quantities.length !== input.unitCents.length ||
          !Array.isArray(input.presets) || input.presets.length === 0) {
        throw new Error('Air Freshener product row is invalid.');
      }
      var prior = 0;
      var quantities = input.quantities.map(function (value, index) {
        var quantity = positiveInteger(value);
        var unitCents = positiveInteger(input.unitCents[index]);
        if (!quantity || !unitCents || quantity <= prior) {
          throw new Error('Air Freshener pricing tiers are invalid.');
        }
        prior = quantity;
        return quantity;
      });
      var presets = input.presets.map(positiveInteger);
      var isBoundedPackagedCustom = input.pricingMode === 'bounded_interpolated_flat';
      var customPolicy = input.customQuantityPolicy || {};
      var minimum = positiveInteger(customPolicy.minimum);
      var maximum = positiveInteger(customPolicy.maximum);
      var flatRateAfter = positiveInteger(customPolicy.flatRateAfter);
      var flatRateUnitCents = positiveInteger(customPolicy.flatRateUnitCents);
      var lastIndex = quantities.length - 1;
      if (presets.some(function (value) { return !value || quantities.indexOf(value) === -1; }) ||
          (input.pricingMode === 'exact' && input.allowCustomQuantity !== false) ||
          (input.packaging !== 'none' && input.pricingMode !== 'exact' && !isBoundedPackagedCustom) ||
          (isBoundedPackagedCustom && (input.packaging === 'none' || input.allowCustomQuantity !== true ||
            minimum !== quantities[0] || maximum <= quantities[lastIndex] ||
            flatRateAfter !== quantities[lastIndex] ||
            flatRateUnitCents !== positiveInteger(input.unitCents[lastIndex]) ||
            customPolicy.approval !== 'owner-approved-2026-08-11' ||
            !/^Owner-approved:/.test(String(customPolicy.note || ''))))) {
        throw new Error('Air Freshener quantity contract is invalid.');
      }
      seen[productId] = true;
      return {
        productId: productId,
        handle: handle,
        kind: String(input.kind || ''),
        pricingMode: input.pricingMode,
        quantities: quantities,
        unitCents: input.unitCents.map(positiveInteger),
        presets: presets,
        allowCustomQuantity: input.allowCustomQuantity === true,
        customQuantityPolicy: isBoundedPackagedCustom ? {
          minimum: minimum,
          maximum: maximum,
          flatRateAfter: flatRateAfter,
          flatRateUnitCents: flatRateUnitCents,
          approval: customPolicy.approval,
          note: String(customPolicy.note)
        } : null,
        packaging: input.packaging
      };
    });

    if (Object.keys(EXPECTED_PRODUCTS).some(function (id) { return !seen[id]; })) {
      throw new Error('Air Freshener product contract is incomplete.');
    }

    return {
      version: raw.contractVersion,
      surcharges: {
        extraFragranceCents: 300,
        doubleImageCents: 500
      },
      products: products
    };
  }

  function resolveProduct(contract, productId, handle) {
    var id = positiveInteger(productId);
    var normalizedHandle = normalizeHandle(handle);
    if (!contract || !Array.isArray(contract.products) || !id || !normalizedHandle) {
      throw new Error('Air Freshener source product identity is invalid.');
    }
    var matches = contract.products.filter(function (row) {
      return row.productId === id && row.handle === normalizedHandle;
    });
    if (matches.length !== 1) {
      throw new Error('Air Freshener source product is not supported.');
    }
    return matches[0];
  }

  function interpolateUnitCents(quantity, lowQuantity, highQuantity, lowCents, highCents) {
    if (lowQuantity === highQuantity) return lowCents;
    var ratio = (Math.log(quantity) - Math.log(lowQuantity)) /
      (Math.log(highQuantity) - Math.log(lowQuantity));
    return Math.round(lowCents + ratio * (highCents - lowCents));
  }

  function basePrice(row, quantityValue) {
    var quantity = positiveInteger(quantityValue);
    if (!row || !quantity || !Array.isArray(row.quantities) || !Array.isArray(row.unitCents)) {
      throw new Error('Air Freshener pricing input is invalid.');
    }
    var exactIndex = row.quantities.indexOf(quantity);
    var unitCents;
    if (row.pricingMode === 'bounded_interpolated_flat') {
      var policy = row.customQuantityPolicy;
      if (!policy || quantity < policy.minimum || quantity > policy.maximum) {
        throw new Error('Air Freshener quantity is not supported for this product.');
      }
    }
    if (row.pricingMode === 'exact') {
      if (exactIndex === -1) {
        throw new Error('Air Freshener quantity is not supported for this product.');
      }
      unitCents = row.unitCents[exactIndex];
    } else if (exactIndex !== -1) {
      unitCents = row.unitCents[exactIndex];
    } else if (quantity >= row.quantities[row.quantities.length - 1]) {
      unitCents = row.unitCents[row.unitCents.length - 1];
    } else {
      var upperIndex = row.quantities.findIndex(function (tier) { return tier > quantity; });
      if (upperIndex <= 0) upperIndex = 1;
      var lowerIndex = upperIndex - 1;
      unitCents = interpolateUnitCents(
        quantity,
        row.quantities[lowerIndex],
        row.quantities[upperIndex],
        row.unitCents[lowerIndex],
        row.unitCents[upperIndex]
      );
    }
    return {
      qty: quantity,
      unitCents: unitCents,
      unitPrice: unitCents / 100,
      totalCents: quantity * unitCents,
      total: quantity * unitCents / 100
    };
  }

  function quote(contract, row, input) {
    input = input || {};
    var pricing = basePrice(row, input.quantity);
    var fragranceCount = positiveInteger(input.fragranceCount);
    if (!fragranceCount) throw new Error('Air Freshener fragrance selection is invalid.');
    var fragranceCents = Math.max(0, fragranceCount - 1) * contract.surcharges.extraFragranceCents;
    var doubleImageCents = input.doubleImage === true ? contract.surcharges.doubleImageCents : 0;
    return {
      quantity: pricing.qty,
      unitCents: pricing.unitCents,
      baseTotalCents: pricing.totalCents,
      fragranceCents: fragranceCents,
      doubleImageCents: doubleImageCents,
      totalCents: pricing.totalCents + fragranceCents + doubleImageCents
    };
  }

  return {
    expectedProducts: Object.assign({}, EXPECTED_PRODUCTS),
    prepare: prepare,
    resolveProduct: resolveProduct,
    basePrice: basePrice,
    quote: quote
  };
});
